/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(
        /* webpackChunkName: "communications" */ '@/modules/communications/scenes/communications-list/communications-list.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.COMMUNICATIONS.COMMUNICATIONS_LIST,
    path: 'communications'
  },
  {
    component: () =>
      import(
        /* webpackChunkName: "communications" */ '@/modules/communications/scenes/communications-detail/communications-detail.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.COMMUNICATIONS.COMMUNICATIONS_DETAIL,
    path: 'communications/:id'
  }
] as RouteConfig[];
